<template>
  <v-layout row>
    <v-dialog v-model="dialog" max-width="500px">
      <v-btn
        slot="activator"
        :color="color"
        :small="small"
        :bottom="bottom"
        :top="top"
        :left="left"
        :right="right"
        :absolute="absolute"
        :fab="fab"
        :dark="dark"
        :v-html="text"
        :flat="flat"
      ><v-icon v-if="{icon}">{{icon}}</v-icon>
      </v-btn>

      <v-card>
        <!-- <v-card-title style="background-color:">
          <span class="headline">Create New Issue</span>
        </v-card-title> -->
        <v-toolbar card color="primary">
          <v-toolbar-title><h1>Create New Issue</h1></v-toolbar-title>
        </v-toolbar>
        <v-form @submit.prevent="onSave">
        <v-card-text>
          <v-container grid-list-md>
            <v-layout wrap>
              <v-flex xs12>
                <v-text-field v-model="title" label="Issue Title" required></v-text-field>
              </v-flex>
              <v-flex xs12>
                <v-text-field v-model="description" label="Description" required></v-text-field>
              </v-flex>
              <v-flex xs12>
                <v-select
                  :items="issueCategories"
                  v-model="category"
                  label="Category"
                ></v-select>
              </v-flex>
              <v-flex xs12>
                <v-select
                  :items="priorityLevel"
                  v-model="priority"
                  label="Priority"
                  :hint="priorityHint"
                  required
                ></v-select>
              </v-flex>
              <v-flex xs12>
                <v-text-field v-model="notes" label="Notes"></v-text-field>
              </v-flex>
            </v-layout>
          </v-container>
          <small>* indicates required field</small>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="accent" flat @click.native="dialog = false">Close</v-btn>
          <v-btn color="success" flat type="submit">Submit</v-btn>
        </v-card-actions>
        </v-form>
      </v-card>

    </v-dialog>
  </v-layout>
</template>

<script>
export default {
  data () {
    return {
      dialog: false,
      title: '',
      description: '',
      category: '',
      priority: '',
      notes: '',
      issueCategories: [
        'Documentation',
        'UI/UX',
        'Design',
        'Finance',
        'Marketing',
        'Development',
        'General Business',
        'Bugs/Errors',
        'General/Idea',
        'Other'
      ],
      // Priority level 0 is for ideas/general category
      priorityLevel: ['0','1','2','3','4','5'],
      priorityHint: 'Lowest:5, Highest:1, Ideas:0'
    }
  },
  props: [
    'dark',
    'color',
    'small',
    'bottom',
    'top',
    'left',
    'right',
    'absolute',
    'fab',
    'icon',
    'text',
    'flat'
  ],
  computed: {
    timestamp: function () {
      this.getDate()
    },
    userIsAuthenticated: function () {
      return (this.$store.getters.user !== null && this.$store.getters.user !== undefined)
    }
  },
  methods: {
    getDate: function () {
      return new Date()
    },
    getEmail: function () {
      // var email = this.$store.getters.email
      return (this.userIsAuthenticated) ? this.$store.getters.email : '**INVALID USER**'
    },
    getUID: function () {
      // var uid = this.$store.getters.uid
      return (this.userIsAuthenticated) ? this.$store.getters.uid : '**INVALID USER**'
    },
    onSave: function () {
      var issue = {
        title: this.title,
        description: this.description,
        category: this.category,
        priority: this.priority,
        notes: this.notes,
        email: this.getEmail(),
        date: this.getDate()
      }
      console.log(issue);
      this.$store.dispatch('createIssue', issue)
      this.dialog = false;
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/dialogs/AddIssueForm.vue